import { render, staticRenderFns } from "./TheAttachment.vue?vue&type=template&id=16390252&scoped=true&"
import script from "./TheAttachment.vue?vue&type=script&lang=js&"
export * from "./TheAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16390252",
  null
  
)

export default component.exports